import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "common/css/master.css";
import "../../subjectTeachersAvailability/subjectTeacherAvailability.css";
import Header from "common/js/header/header.js";
import TchSubjectTableBody from "./tchsubjectTableBody";
import {
  getClassList,
  getSectionData,
  getSessionData,
  getTchLst,
  getLstDay,
  getLstPeriod,
  saveTchForCell,
} from "./ttTeacherService";
import TTTeacherBody2 from "./ttTeacherBody2";
import TTTeacherHead from "./ttTchHeader";
import SubjectTeachersAvailability from "sms/tt/subjectTeachersAvailability/subjectTeachersAvailablity";

var MAX_SUB = 4;
var gClsId = 0;
function TTTeacherCtrl2() {
  var initialState = {
    loader: "none",
    opacity: 1,
  };
  const [flgSuccess, setFlgSuccess] = useState(true);
  const [ttbodyKey, setTTBodyKey] = useState(0);
  const [tchbodyKey, setTchBodyKey] = useState(0);
  // const [cellKey, setCellKey] = useState(0);
  const [state, setState] = useState(initialState);
  const [clsId, setClsId] = useState(0);
  const [classId, setClassId] = useState(0);
  const [sectionId, setSectionId] = useState(0);
  const [sessionId, setSessionId] = useState(0);
  const [selClsLabel, setSelClsLabel] = useState("");
  const [selSectionLabel, setSelSectionLabel] = useState("");
  const [cellId, setCellId] = useState(0);
  const [refreshDayId, setRefreshDayId] = useState(0);
  const [refreshPeriodId, setRefreshPeriodId] = useState(0);
  const [cell, setCell] = useState({});
  const [lstCls, setLstCls] = useState([]);
  const [lstSection, setLstSection] = useState([]);
  const [lstSession, setLstSession] = useState([]);
  const [lstTch, setlstTch] = useState([]);
  const [lstDay, setLstDay] = useState([]);
  const [lstPeriod, setLstPeriod] = useState([]);
  // const [selSubId, setSelSubId] = useState(0);
  const [selDayId, setSelDayId] = useState(0);
  const [selPeriodId, setSelPeriodId] = useState(0);
  const [selCellDtls, setSelCellDtls] = useState({});
  const [selTchId, setSelTchId] = useState(0);
  const [classLabel, setClassLabel] = useState({});
  const [cellRefresh, setCellRefresh] = useState(false);
  const [selectCellDtls, setSelectCellDtls] = useState({});
  const [selSubPosId, setSelSubPosId] = useState(0);
  const [selCellId, setSelCellId] = useState(0);
  const [flgAvailabilityReportVisible, setFlgAvailabilityReportVisible] = useState(false);
  const params = new URLSearchParams(window.location.search);
  useEffect(() => {
    setClass();
    // setTchLst(sessionId, clsId, sectionId);
    setDay(handleDaysResponse);
    // setClsId(clsId);
    // setSectionId(sectionId);
    // setSessionId(sessionId);
    // console.log("inside useeffect");
    // console.log("clsId ", clsId);
    // console.log(" sectionId", sectionId);
    // console.log(" sessionId", sessionId);
    // console.log("lstCls", lstCls);
    gClsId = params.get("clsId")
    if (gClsId) {
      setClassId(gClsId);
      if (params.get("sectionId")) {
        // console.log("sectionId get using params",params.get("sectionId"));
        setSectionId(params.get("sectionId"));
        setSection(params.get("clsId"));
        if (params.get("sessionId")) {
        }
        setSessionId(params.get("sessionId"));
        setSession(params.get("clsId"));
        // console.log("setPeriod going to be called from useEffect 4");
        setPeriod(params.get("sessionId"))
      }
    }
    // console.log("clsId ", clsId);
    // console.log(" sectionId", sectionId);
    // console.log(" sessionId", sessionId);
  }, []);

  function setClass() {
    // return new Promise((resolve) => {
    showLoader();
    getClassList(handleClassResponse);
    //   resolve();
    // });
  }
  function showLoader() {
    setState({ ...state, loader: "block", opacity: 0.5 });
  }
  function hideLoader() {
    setState({ ...state, loader: "none", opacity: 1 });
  }
  function handleClassResponse(data) {
    // return new Promise((resolve) => {
    hideLoader();
    var obj = data;
    // console.log("handleClassResponse = " + JSON.stringify(data));
    if (obj.status === "Success") {
      setLstCls(obj.lstCls);
      // console.log("obj.lstcls", obj.lstCls);
    } else if (obj.status === "Failure") {
      setLstCls([]);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
    //   resolve();
    // });
  }

  function setSection(clasId) {
    // console.log("setSection called, classid passed", clasId);
    showLoader();
    getSectionData(clasId, handleSectionResponse);
  }

  async function handleSectionResponse(data) {
    // console.log("handleSectionResponse called, data", data);
    hideLoader();
    var obj = data;
    if (obj.status === "Success") {
      await setLstSection(obj.lstSection);
      if (obj.lstSection) {
        changeSection(obj.lstSection[0].sectionId, obj.lstSection[0].section);
      }
    } else if (obj.status === "Failure") {
      setLstSection([]);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
  }

  function setSession(clsId) {
    showLoader();
    getSessionData(handleSessionResponse, clsId);
  }

  function handleSessionResponse(data) {
    hideLoader();
    var obj = data;
    if (obj.status === "Success") {
      setLstSession(obj.lstSession);
    } else if (obj.status === "Failure") {
      setLstSession([]);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
  }

  function handleLstTchResponse(data) {
    hideLoader();
    var obj = data;
    if (obj.status === "Success") {
      setlstTch(obj.lstTch);
    } else if (obj.status === "Failure") {
      setlstTch([]);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
  }
  function setTchLst(sessionId, clsId, sectionId) {
    showLoader();
    // console.log(' setTchList() sessionId, clsId, sectionId', sessionId, clsId, sectionId)
    getTchLst(sessionId, clsId, sectionId, handleLstTchResponse);
  }

  function setDay(handleDaysResponse) {
    showLoader();
    getLstDay(handleDaysResponse);
  }

  function handleDaysResponse(data) {
    hideLoader();
    var obj = data;
    if (obj.status === "Success") {
      setLstDay(obj.lstDay);
    } else if (obj.status === "Failure") {
      setLstDay([]);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
  }

  function setPeriod(sessionId) {
    // console.log("setPeriod called");
    showLoader();
    getLstPeriod(sessionId, handlePeriodResponse);
  }

  function handlePeriodResponse(data) {
    // console.log("handlePeriodResponse called, 1");
    hideLoader();
    var obj = data;
    if (obj.status === "Success") {
      setLstPeriod(obj.lstPeriod);
      // console.log("setTTBodyKey called in handlePeriodResponse 1");
      setTTBodyKey(generateRandNo);
    } else if (obj.status === "Failure") {
      setLstPeriod([]);
      // console.log("setTTBodyKey called handlePeriodResponse 2");
      setTTBodyKey(generateRandNo);
      if (obj.message === "You are not logged in") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else if (obj.message === "Your Session is expired, login again") {
        setTimeout(function () {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    } else {
      toast.error("Service failed " + obj);
    }
  }

  async function changeClass(clsId, clsLabel) {
    let wingId = 1;
    let screenId = 33;
    gClsId = clsId;
    await setState({ ...state, classId: gClsId });
    await setClassId(gClsId);

    // console.log('sel cls id = ' +clsId+' sel cls = ' + clsLabel)
    await setSelClsLabel(clsLabel);
    // console.log("changeClass: " + clsId);
    await setSection(gClsId, handleSectionResponse);
    await setSession(gClsId);
  }
  function generateRandNo() {
    return Math.floor(Math.random() * 999999);
  }
  async function changeSection(pSectionId, pSectionLabel) {
    let wingId = 1;
    let screenId = 33;
    // console.log(pSectionId)
    if (gClsId && sessionId) {
      // console.log('changeSection sessionId, classId, pSectionId',sessionId, gClsId, pSectionId)
      await setTchLst(sessionId, gClsId, pSectionId);
      await setDay(handleDaysResponse);
      // console.log("setPeriod going to be called from changeSection 2")
      await setPeriod(sessionId);
      //setTTBodyKey(generateRandNo)
      await setTchBodyKey(generateRandNo);
    }
    await setState({ ...state, sectionId: pSectionId });
    await setSectionId(pSectionId);
    // console.log("changeSection: " + pSectionId);
    // console.log('section: ' + pSectionLabel)
    await setSelSectionLabel(pSectionLabel);
  }

  function changeSession(pSessionId) {
    let wingId = 1;
    let screenId = 33;
    if (gClsId && sectionId) {
      setTchLst(pSessionId, gClsId, sectionId);
      setDay(handleDaysResponse);
      // console.log("setPeriod going to be called from changeSession3");
      setPeriod(pSessionId);
      //setTTBodyKey(generateRandNo)
      setTchBodyKey(generateRandNo);
    }
    setState({ ...state, sessionId: pSessionId });
    setSessionId(pSessionId);
    // console.log(pSessionId)
  }

  function onClickCell(e, dId, pId, classSectionId, pPos) {
    setSelSubPosId(1);
    var subCtr;
    // console.log('flgSuccess: ' + flgSuccess);
    if (flgSuccess) {
      subCtr = pPos + 1 > MAX_SUB ? MAX_SUB : pPos + 1;
    } else {
      subCtr = pPos > MAX_SUB ? MAX_SUB : pPos;
    }
    // console.log("hi" + subCtr);
    // console.log(e.currentTarget);
    var cellData = e.currentTarget.querySelector(".sub").getAttribute("cell");
    // console.log(typeof JSON.parse(cellData));
    var selCellId = JSON.parse(cellData).cellId;
    // setCellId(selCellId);
    var cell = e.currentTarget.getAttribute("selcelldtls");
    // console.log('pId= ' + pId + ', dId = ' + dId + ', selCellId = ' + selCellId)
    // setState({ ...state, selCellDtls: cell, selDayId: e.target.seldayid, selPeriodId: e.target.selperiodid });
    var cellDtls = {
      cellId: selCellId,
      classSectionId: classSectionId,
      schedulePeriodId: pId,
      dayId: dId,
      subPosition: subCtr,
    };
    // console.log(cellDtls);
    setSelCellDtls(cellDtls);
    setSelPeriodId(pId);
    setSelDayId(dId);
    // setCellId(cellDtls.cellId)
  }
  function setCellProps(pCellDtls, pCellId, pFlgSuccess) {
    setFlgSuccess(pFlgSuccess);
    // console.log("setcellprops")

    if (pFlgSuccess) {
      pCellDtls.cellId = pCellId;
      pCellDtls.subPosition =
        pCellDtls.subPosition > MAX_SUB
          ? 1
          : pCellDtls.subPosition == MAX_SUB
            ? MAX_SUB
            : pCellDtls.subPosition;
      setSelTchId(pCellDtls.tchId);
      // pCellDtls.subPosition = pCellDtls.subPosition + 1 > MAX_SUB ? 1 : pCellDtls.subPosition + 1 == MAX_SUB ? MAX_SUB : pCellDtls.subPosition + 1;
    } else {
      pCellDtls.cellId = pCellId;
      pCellDtls.subPosition =
        pCellDtls.subPosition >= MAX_SUB ? MAX_SUB : pCellDtls.subPosition;
    }
    setSelCellDtls(pCellDtls);
    // setCellId(pCellId);
    setSelCellId(pCellId);
    setSelSubPosId(pCellDtls.subPosition);
    // console.log(document.querySelector('td.selected-cell'))
    // document.querySelector('td.selected-cell').closest('div').click();
    setCellRefresh(true);
  }
  const sortAscTotal = async (e) => {
    // console.log("reached")
    const sorted = await lstTch.sort((a, b) => {
      // console.log(a, b)
      return a.overallPct - b.overallPct;
    });
    setlstTch(sorted);
    setTchBodyKey(generateRandNo);
  };
  const sortDscTotal = async (e) => {
    // console.log("reached")
    const sorted = await lstTch.sort((a, b) => {
      // console.log(a, b)
      return b.overallPct - a.overallPct;
    });
    setlstTch(sorted);
    setTchBodyKey(generateRandNo);
  };
  const sortAscAllocation = async (e) => {
    // console.log("reached")
    const sorted = await lstTch.sort((a, b) => {
      // console.log(a, b)
      return a.pct - b.pct;
    });
    setlstTch(sorted);
    setTchBodyKey(generateRandNo);
  };
  const sortDscAllocation = async (e) => {
    // console.log("reached")
    const sorted = await lstTch.sort((a, b) => {
      // console.log(a, b)
      return b.pct - a.pct;
    });
    setlstTch(sorted);
    setTchBodyKey(generateRandNo);
  };
  function onClickSubCell(
    e,
    pCellId,
    pDayId,
    pPeriodId,
    pSubPosId,
    pTchId,
    pClassSectionId, pCellDtls
  ) {
    // console.log('442:', pCellDtls)
    setSelectCellDtls(pCellDtls)
    pSubPosId = parseInt(pSubPosId) + 1;
    setSelCellId(pCellId);
    setSelSubPosId(pSubPosId);
    var subCtr;
    if (flgSuccess) {
      subCtr = pSubPosId + 1 > MAX_SUB ? MAX_SUB : pSubPosId + 1;
    } else {
      subCtr = pSubPosId > MAX_SUB ? MAX_SUB : pSubPosId;
    }
    var cellDtls = {
      cellId: pCellId,
      classSectionId: pClassSectionId,
      schedulePeriodId: pPeriodId,
      dayId: pDayId,
      subPosition: pSubPosId,
    };
    setSelCellDtls(cellDtls);
    setSelPeriodId(pPeriodId);
    setSelDayId(pDayId);
  }
  const getWingId = (wingId) => {
    // console.log("wingId" + wingId);
  };

  const openAvailibilityReport = () => {
    // console.log("openPopup called");
    // setState({ ...state, opacity: 0.5 });
    setFlgAvailabilityReportVisible(true);
  }
  
  const closeAvailibilityReport = () => {
    // console.log("closePopup called");
    // setState({ ...state, opacity: 1 });
    setFlgAvailabilityReportVisible(false);
  }

  return (
    <div style={{ pointerEvents: state.opacity === 1 ? "auto" : "none" }}>
      <Header wingFromChild={getWingId} />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: state.loader,
        }}
      >
        <img
          className="loderImg"
          src={require("common/images/loader.gif")}
          alt="Loader..."
        />
      </div>
      <div className="MainContainer" style={{ opacity: state.opacity }}>
        <div className="col-md-12 col-centered wingsWrap clearfix">
          {lstCls && lstCls.length !== 0 && (
            <TTTeacherHead
              changeClass={changeClass}
              changeSection={changeSection}
              changeSession={changeSession}
              lstSession={lstSession}
              lstSection={lstSection}
              lstCls={lstCls}
              //   selSectionId={sectionId}
              selSessionId={sessionId}
              classId={gClsId}
              sectionId={sectionId}
              sessionId={sessionId}
            //   getClassName={getClassName}
            />
          )}
          <div className="row" style={{ marginTop: "1%", height: "38em" }}>
            {/* <div className="col-sm-12 padding-remove" style={{ marginTop: '1%', height: '38em' }}> */}
            <div className="col-sm-12 padding-remove">
              {lstDay && lstPeriod && lstPeriod.length !== 0 && (
                <TTTeacherBody2
                  key={ttbodyKey}
                  cellId={cellId}
                  selCellId={selCellId}
                  selClsLabel={selClsLabel}
                  selSectionLabel={selSectionLabel}
                  lstTch={lstTch}
                  selTchId={selTchId}
                  classLabel={selClsLabel}
                  sectionLabel={selSectionLabel}
                  //rowClick={rowClickInMain}
                  tchbodyKey={tchbodyKey}
                  // cellKey={cellKey}
                  lstDay={lstDay}
                  lstPeriod={lstPeriod}
                  classId={gClsId}
                  classSectionId={sectionId}
                  sessionId={sessionId}
                  // selSubId={selSubId}
                  selDayId={selDayId}
                  selPeriodId={selPeriodId}
                  // refreshDayId={refreshDayId}
                  // refreshPeriodId={refreshPeriodId}
                  //selTchId={selTchId}
                  onClickCell={onClickCell}
                  onClickSubCell={onClickSubCell}
                  sortAscTotal={sortAscTotal}
                  sortDscTotal={sortDscTotal}
                  sortAscAllocation={sortAscAllocation}
                  sortDscAllocation={sortDscAllocation}
                  selCellDtls={selCellDtls}
                  setSelCellDtls={setSelCellDtls}
                  setCellId={setCellId}
                  cellRefresh={cellRefresh}
                  // setCellRefresh={setCellRefresh}
                  selectCellDtls={selectCellDtls}
                  setCellProps={setCellProps}
                  selSubPosId={selSubPosId}
                  openAvailibilityReport={openAvailibilityReport}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {flgAvailabilityReportVisible ?
        <div className="subTchAvailabilityPopup">
          <SubjectTeachersAvailability
            selSessionId={sessionId}
            closePopup={closeAvailibilityReport}
            selSectionId={sectionId}
          />
        </div>
        : null}
    </div>
  );
}

export default TTTeacherCtrl2;
